import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['toggleButton'];

  toggle(e) {
    const sidepanelId = e.currentTarget.dataset.sidepanelId;
    const active = !e.currentTarget.classList.contains('is-active');

    this.dispatch('switch-sidepanel', {
      detail: { sidepanelId, active },
      target: document,
      prefix: false,
    });
  }

  switch(e) {
    const sidepanelId = e.detail.sidepanelId;
    const isActive = e.detail.active;

    this.toggleButtonTargets.forEach((button) => {
      const active = button.dataset.sidepanelId === sidepanelId && isActive;
      button.classList.toggle('is-active', active);
    });
  }
}
